<!--
  nav-link-collapse
  is the first link in an expanded menu (on mobile), is used to collapse the menu's second menu
  when the second level menu is open it will listen to select:menu:first event
-->

<template>
  <a href="#" @click="collapseGroup" class="nav__mobile-drawer-link-a">
    <slot />
  </a>
</template>

<script>
import eventBus from '@/js/util/eventBus'
export default {
  props: {
    group: {
      type: String,
    },
  },
  methods: {
    collapseGroup(event) {
      event.preventDefault()
      eventBus.$emit('nav:link:' + this.group, false)
      this.$nextTick(function() {
        eventBus.$emit('nav:parent:' + this.group)
      })
    },
    setFocus: function() {
      this.$el.focus()
    },
  },
  mounted() {
    eventBus.$on('select:menu:first', this.setFocus)
  },
}
</script>
